<template>
  <div v-show="visible" class="list-filter-panel" @keydown.enter.prevent="handleEnter">
    <slot />
    <div class="list-filter-panel__actions">
      <el-button size="small" type="primary" @click="$emit('apply')">查询</el-button>
      <el-button size="small" @click="$emit('reset')">重置</el-button>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  visible: { type: Boolean, default: false },
})

const emit = defineEmits(['apply', 'reset'])

const handleEnter = (e) => {
  // 仅在输入框、下拉框等表单元素内按回车时触发查询
  const target = e.target
  if (!target) return
  const tagName = target.tagName?.toLowerCase()
  if (['input', 'textarea', 'select'].includes(tagName)) {
    emit('apply')
  }
}
</script>
